module.exports = __webpack_public_path__ + "img/img-bi@2x.26da1e95.png";